import React from "react";
import Message from "assets/scripts/components/common/Message/Message";
const HelpBlock = ({ id, help }) => (<span id={id || undefined} className="help-block">
		<Message value={help}/>
	</span>);
export default HelpBlock;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/FormGroup/HelpBlock.tsx